import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '@shared/services/common.service';

@Component({
  selector: 'app-text-editor-v2',
  template: `<div appDisableRightClick class="ql-editor" [innerHTML]="editorText"></div>`,
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./text-editor-v2.component.scss']
})
export class TextEditorV2Component {
  @Input() editorText;

  constructor(
    private sanitizer: DomSanitizer,
    private cs: CommonService
  ) { }

  ngOnChanges() {
    if (this.editorText) {
      this.editorText = this.sanitizer.bypassSecurityTrustHtml(this.editorText);

      if (this.cs.isBrowser) {
        const videos = document.querySelectorAll('video');
        videos.forEach((video: HTMLVideoElement) => {
          if (!video.hasAttribute('controlslist')) {
            video.setAttribute('controlsList', 'nodownload');
          }
          video.setAttribute('oncontextmenu', 'return false');
        });

        const audios = document.querySelectorAll('audio');
        audios.forEach((audio: HTMLAudioElement) => {
          if (!audio.hasAttribute('controlslist')) {
            audio.setAttribute('controlsList', 'nodownload');
          }
          audio.setAttribute('oncontextmenu', 'return false');
        });
      }
    }
  }

}
